import { createContext, useContext } from 'react';

/**
 * @typedef Identity
 * @property {string} [accountUuid] The account's UUID
 * @property {string} [accountEmail] The account management email
 * @property {string} [userUuid] The user's UUID
 * @property {string} [email] The user's email
 * @property {string} [firstName] The user's given name
 * @property {string} [lastName] The user's family name
 * @property {string} [name] The user's full name
 * @property {Date} [createdAt] When the user's account was created
 */

/**
 * @typedef IdentityContextObject
 * @property {boolean} authenticated User is logged in
 * @property {boolean} identified User's account has been loaded
 * @property {Identity} user
 * @property {string} [accountUuid] The account's UUID
 * @property {string} [accountEmail] The account management email
 * @property {string} [userUuid] The user's UUID
 * @property {string} [email] The user's email
 * @property {string} [firstName] The user's given name
 * @property {string} [lastName] The user's family name
 * @property {string} [name] The user's full name
 * @property {Date} [createdAt] When the user's account was created
 */

/**
 * @type {import('react').Context<IdentityContextObject>}
 */
export const IdentityContext = /*#__PURE__*/createContext(null);

/**
 * React hook for retrieving the current user context.
 *
 * @returns {IdentityContextObject}
 */
export function useIdentity() {
  return useContext(IdentityContext) || null;
}